let configSettings = require('../../static/config.json');
import  authService  from '@/services/authService';
import timezoneJSON from '@/components/timezone.json'
import moment from 'moment';

export default{
	name:'CommonFactory',
	data(){
		return {
            minSearchStrLength:3,
            loading:false,
            userMsg:{show:false,type:'info',list:[]},
            toasterObj:null,
            supportEmail:null,
            editorObj:null,
            captchaSiteKey:null,
            priceList:[],
            toasterObj:null,

        };
    },
    computed:{
        notifyList(){
            return this.userMsg.list;
        }
    },
    watch:{
		notifyList:function(val, oldVal) {
            const _self=this;
            setTimeout(function(){_self.fn().showToasterMsg(_self.userMsg.list,true);},500);
            //_self.fn().showToasterMsg(_self.userMsg.list,true);
    	},
    },
    created(){
        let _self=this;
        _self.fn().initCommon();
        _self.initPriceList();
    },
    beforeDestroy(){
        let _self=this;
        _self.fn().destoryEditorObj();
    },
    methods:{
        initPriceList(){
            let features=[
				{name:'Create Azure DevOps work item',isFree:1,isPaid:1,isPremium:1,isEnterprise:true},
				{name:'Link Azure DevOps work item',isFree:1,isPaid:1,isPremium:1,isEnterprise:true},
				{name:'Notify Azure DevOps work item',isFree:1,isPaid:1,isPremium:1,isEnterprise:true},
				{name:'View Work Item History and status',isFree:1,isPaid:1,isPremium:1,isEnterprise:true},
				{name:'Unlink Work Item',isFree:0,isPaid:1,isPremium:1,isEnterprise:true},
				{name:'Unlimited users access',isFree:0,isPaid:1,isPremium:1,isEnterprise:true,showStar:true},
				{name:'24*7 SLA support',isFree:0,isPaid:1,isPremium:1,isEnterprise:true,showStar:true},
				{name:'Access to all projects',isFree:0,isPaid:0,isPremium:1,isEnterprise:true,showStar:true},
				{name:'Custom work item types',isFree:0,isPaid:0,isPremium:1,isEnterprise:true,showStar:true},
				//{name:'Advance customization',isFree:0,isPaid:0,isPremium:1,isEnterprise:true},
				{name:'Two-way comment sync',isFree:0,isPaid:0,isPremium:1,isEnterprise:true,showStar:true},
				{name:'DevOps Status sync',isFree:0,isPaid:0,isPremium:1,isEnterprise:true,showStar:true},
                {name:'Work Item Search',isFree:0,isPaid:0,isPremium:0,isEnterprise:true,showStar:true},
                {name:'Upload Files',isFree:0,isPaid:0,isPremium:0,isEnterprise:true,showStar:true},
                {name:'Customize View',isFree:0,isPaid:0,isPremium:0,isEnterprise:true,showStar:true},
                {name:'Advance Customization',isFree:0,isPaid:0,isPremium:0,isEnterprise:1,showStar:true},
			];
			this.priceList=[
				{name:'Free Trial',cost:0,isFree:true,features:features,ticketsCount:20,agentsCount:5},
                {name:'Pro',cost:15,isPaid:true,features:features,ticketsCount:25,agentsCount:5},
				{name:'Plus',cost:59,isPaid:true,features:features,ticketsCount:100,agentsCount:5},
				{name:'Premium',cost:125,isPremium:true,features:features,ticketsCount:300,agentsCount:10},
                {name:'Enterprise',cost:0,isEnterprise:true,features:features,ticketsCount:0,agentsCount:0}
			]
        },
        fn(){
            let _self=this;
            return {
                initCommon(){
                    _self.supportEmail=configSettings.supportEmail;
                    _self.captchaSiteKey=configSettings.captchaSiteKey;
                },
                replaceAll(str,find,replace){
                    return str.replace(new RegExp(find, 'g'), replace?replace:'');
                },
                showInlineInfoMsg(val){
                    _self.fn().showToasterMsg(val,false);
                },
                showToasterMsg(val,autoHide){
                    if(val && !Array.isArray(val))val=val.split(',');

                    if(!val || val.length<=0) return;//clearing the message
                    _self.$toasted.clear();//clear all other toasts
                    let message=val.join(",\r\n");
                    let type=_self.userMsg.type;
                    type=type?type:'danger';
                    let options={
                        type : type,
                        singleton:true,
                        keepOnHover:true,
                        //fullWidth:true,
                        //fitToScreen:true,
                        iconPack:'fontawesome',
                        position:'bottom-right',
                        theme:'outline',//['toasted-primary', 'outline', 'bubble']
                        //icon : 'error_outline'
                    };
                    if(!autoHide){
                        options.action = {
                            text : 'Close',
                            class:'text-white',
                            onClick : (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        }
                    }
                    let toaster;
                    switch(type){
                        case 'info':
                          toaster=_self.$toasted.info(message,options);
                        break;
                        case 'primary':
                            toaster=_self.$toasted.success(message,options);
                        break;
                        case 'success':
                            toaster=_self.$toasted.success(message,options);
                        break;
                        case 'danger':
                            toaster=_self.$toasted.error(message,options);
                        break;
                        default:
                            toaster=_self.$toasted.show(message,options);
                        break;
                    }
                    if(autoHide){
                        toaster.goAway(2500);
                    }
                    //_self.toasterObj=toaster;
              },
              isApiTokenAuthAllowed(appId,installationId) {
                  let allowedInstallationIds =
                    configSettings.allowedAPITokenAuth_userInstallationIds &&
                    configSettings.allowedAPITokenAuth_userInstallationIds[
                      "appId_" + appId
                    ];

                  if (!allowedInstallationIds) {
                    return false;
                  }

                  for (let i = 0; i < allowedInstallationIds.length; i++) {
                    let id = String(allowedInstallationIds[i]).trim();

                    if (id === String(installationId)) {
                      return true;
                    }
                  }

                  return false;
                },
                //https://www.dropzonejs.com/#configuration
                initDropzone(el,params,type,cb){
                    let url;
                    switch(type){
                        case `devops`:
                            url=`${configSettings.apiUrl}/devops/uploadFile`;
                        break;
                        case `github`:
                            //url=`${configSettings.apiUrl}/files/upload/zendesk`;
                            url=`${configSettings.apiUrl}/files/upload/github`;
                        break;
                        case `asana`:
                            url=`${configSettings.apiUrl}/files/upload/asana`;
                        break;
                    }
                    //console.log('api url',url,'and ',type,' and config',configSettings.apiUrl);

                    if(!url) return;

                    let acceptedFiles=null;
                    if(_self.zendeskInfo && _self.zendeskInfo.userInfo
                        && _self.zendeskInfo.userInfo.acceptedFiles){
                            acceptedFiles=_self.zendeskInfo.userInfo.acceptedFiles;
                            //console.log('acceptedFiles',acceptedFiles);
                        }

                    var myDropzone = new Dropzone(el, {
                        url: url,
                        params:params,
                        maxFilesize: 5, // MB
                        parallelUploads:1,
                        uploadMultiple:false,
                        acceptedFiles: acceptedFiles,
                        maxFiles:1,
                    });
                    // myDropzone.on('sending', function(file, xhr, formData){
                    //     for(var key in params){
                    //         formData.append(key, params[key]);
                    //     }
                    // });
                    myDropzone.on("addedfile", function(file) {
                        //already one file in progress
                        //checking if file upload already in queue
                        if(_self.loading){
                            myDropzone.removeFile(file);
                            return;
                        }
                        _self.fn().showLoader(true);
                    });
                    myDropzone.on("success", function(file) {
                        myDropzone.removeFile(file);
                        _self.fn().showLoader(false);
                        if(file.status=='success'){
                            let response=file.xhr.response?JSON.parse(file.xhr.response):null;
                            if(response && response.Success && response.Data){
                                if(cb) cb(null,response.Data);
                            }else{
                                if(cb) cb('Error',response.Data);
                            }
                        }
                        /* Maybe display some more file information on your page */
                    });
                    myDropzone.on("error", function(file, message, xhr) {
                        myDropzone.removeFile(file);
                        _self.fn().showLoader(false);
                        console.log(message);
                        if(cb) cb('Error',message);
                     });
                },
                getBase64(file,cb) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        if(cb) cb(null,reader.result);
                        //console.log(reader.result);
                    };
                    reader.onerror = function (error) {
                        if(cb) cb(error);
                      console.log('Error: ', error);
                    };
                },
                getGitHubOrg:function(url){
                    if(!url) return url;
                    url=url.endsWith('/')?url.substr(0,url.length-1):url;
                    let orgName=url.split('/')[url.split('/').length-1];
                    return orgName;
                },
                getDevOpsOrg:function(url){
                    if(!url) return url;
                    let orgName;
                    if(url.indexOf('.visualstudio.com')>=0){
                        orgName=url.split('.visualstudio.com')[0].replace('https://','');
                    }else{
                        url=url.endsWith('/')?url.substr(0,url.length-1):url;
                        orgName=url.split('/')[url.split('/').length-1];
                    }
                    return orgName;
                },
                getFSTicketUrl:function(hdLoginUrl,hdTicketId,type){
                    let ticketUrl;
                    if(type=='ticket') ticketUrl=`${hdLoginUrl}/helpdesk/tickets/${hdTicketId}`;
                    if(type=='change') ticketUrl=`${hdLoginUrl}/itil/changes/${hdTicketId}`;
                    return ticketUrl;
                },
                getSubdomain:function(url){
                    if(!url) return url;
                    url = /:\/\/([^\/]+)/.exec(url)[1];
                    var parts = url.split('.')
                    var sub = parts[0]
                    var domain = parts[1]
                    var type = parts[2]
                    return sub;
                },
                getLoggedInUser(){
                    let authResponse=authService.getAuthResponse();
                    if(authResponse)
                        return JSON.parse(authResponse).User;
                    else
                        return null;
                },
                isZendeskDomainValidRegex(subDomain) {
                    const _self = this;
                    const regex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)(?:\.(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?))*$/;
                    return regex.test(subDomain);
                },
                getCurrentUrl(){
                    return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
                },
                async getMondayData_Child(appId,installationId,hdBoardId,hdItemId) {
                    let cacheOptions = {appId:appId,installationId:installationId, hdBoardId: hdBoardId, hdItemId: hdItemId };

                    //console.log('cacheOptions getMondayData_Child', cacheOptions);
                    let storageData = await mondayClient.storage.instance.getItem('mondayInfo', cacheOptions);
                    return JSON.parse(storageData.data.value);
                },
                async setUpdateMondayData_Child(mondayInfo,hdBoardId,hdItemId) {
                    let cacheOptions = { hdBoardId: hdBoardId, hdItemId: hdItemId };
                    if (mondayInfo.credentials) {
                        cacheOptions.appId = mondayInfo.credentials.appId;
                        cacheOptions.installationId=mondayInfo.credentials.installationId;
                    }
                    //console.log('cacheOptions setUpdateMondayData_Child', cacheOptions);
                    await mondayClient.storage.instance.deleteItem('mondayInfo', cacheOptions);
                    await mondayClient.storage.instance.setItem('mondayInfo', JSON.stringify(mondayInfo), cacheOptions);

                },
                create_monday_modal(action,size,triggerInstance,cbInstance,data,cb){
                    //let url=`${this.getCurrentUrl()}/${action}`;
                    let url = `/monday-devops/${action}`;
                    size = size ? size : { width: '80vw', height: '80vw' };
                    let params = {
                        urlPath: url,
                        height: size.height,
                        width: size.width
                    };
                    mondayClient.execute("openAppFeatureModal",params).then((res) => {
                        //if model is closing
                        if (res && res.data && res.data.closed == true) {
                            _self.fn().destoryEditorObj();
                            if(cb) cb();
                        }
                    });

                    //https://github.com/bryan-flynn-zd/examples/blob/master/demo_app_send_data_back_from_modal/assets/iframe.html

                    // client.on('receive_data_from_modal', (modalData) => {
                    //     if(cb) cb(modalData);
                    // })
                    // if(triggerInstance){
                    //     client.on('instance.registered', (context) => {
                    //         if (context.location === 'modal') {
                    //             let instanceGuid = context.instanceGuid
                    //             let modalClient = client.instance(instanceGuid)
                    //             // Send modal this client's instance guid via trigger.
                    //             // The modal will use the guid to get a client instance back to this parent.
                    //             data=data?data:_self.zendeskInfo;
                    //             data.parentClientGuid=client._instanceGuid;
                    //             modalClient.trigger(triggerInstance, data)
                    //         }
                    //     });
                    // }
                    // if(cbInstance){
                    //     client.on(cbInstance, (modalData) => {
                    //         if(cb) cb(modalData);
                    //     })
                    // }
                },
                openOAuthPopup(url) {
                    const popup = window.open(
                        url,
                        "zendeskOAuth",
                        "width=900,height=700"
                    );

                    if (!popup || popup.closed || typeof popup.closed === "undefined") {
                        // Popup was blocked
                        console.log("Popup blocked");
                        return false;
                    }

                    // Popup opened successfully
                    popup.focus();
                    return true;
                },
                async getAllOrganizations(clientObj) {
                  let organizations = [];
                  let nextPage = '/api/v2/organizations.json?per_page=100';

                  while (nextPage) {
                    //console.log('next page see', nextPage);
                    const response = await clientObj.request({
                      url: nextPage,
                      type: 'GET',
                      dataType: 'json'
                    });

                    organizations = organizations.concat(response.organizations);
                    nextPage = response.next_page;
                  }

                  return organizations;
                },
                close_monday_modal(data) {
                    let _self = this;
                    mondayClient.execute("closeAppFeatureModal").then((res) => {
                        console.log(res.data);
                    });

                },
                // async getZendeskData_Child(appId,installationId,hdTicketId) {
                //     let cacheOptions = {appId:appId,installationId:installationId, hdTicketId: hdTicketId };

                //     //console.log('cacheOptions getZendeskData_Child', cacheOptions);
                //     // let storageData = await zendeskClient.storage.instance.getItem('mondayInfo', cacheOptions);
                //     // return JSON.parse(storageData.data.value);
                // },
                // async setUpdateZendeskData_Child(zendeskInfo,hdTicketId) {
                //     let cacheOptions = { hdTicketId: hdTicketId };
                //     if (zendeskInfo.credentials) {
                //         cacheOptions.appId = mondayInfo.credentials.appId;
                //         cacheOptions.installationId=mondayInfo.credentials.installationId;
                //     }
                //     //console.log('cacheOptions setUpdateMondayData_Child', cacheOptions);
                //     await zendeskClient.storage.instance.deleteItem('zendeskInfo', cacheOptions);
                //     await zendeskClient.storage.instance.setItem('zendeskInfo', JSON.stringify(zendeskInfo), cacheOptions);

                // },
                //https://developerblog.zendesk.com/making-modals-work-in-zaf-v2-251b7c940e58
                create_zendesk_modal(action,size,triggerInstance,cbInstance,data,cb){
                    let url=`${this.getCurrentUrl()}/${action}`;
                    size=size?size: { width: '80vw',height: '80vw'};
                    client.invoke('instances.create', {
                        location: 'modal',
                        url:`${url}`,
                        size: size
                    }).then(function(modalContext) {
                        // The modal is on screen now
                        var modalClient = client.instance(modalContext['instances.create'][0].instanceGuid);
                        modalClient.on('modal.close', function() {
                            // The modal has been closed
                            _self.fn().destoryEditorObj();
                            if(cb) cb();
                        });
                    });

                    //https://github.com/bryan-flynn-zd/examples/blob/master/demo_app_send_data_back_from_modal/assets/iframe.html

                    client.on('receive_data_from_modal', (modalData) => {
                        if(cb) cb(modalData);
                    })
                    if(triggerInstance){
                        client.on('instance.registered', (context) => {
                            if (context.location === 'modal') {
                                let instanceGuid = context.instanceGuid
                                let modalClient = client.instance(instanceGuid)
                                // Send modal this client's instance guid via trigger.
                                // The modal will use the guid to get a client instance back to this parent.
                                data=data?data:_self.zendeskInfo;
                                data.parentClientGuid=client._instanceGuid;
                                modalClient.trigger(triggerInstance, data)
                            }
                        });
                    }
                    if(cbInstance){
                        client.on(cbInstance, (modalData) => {
                            if(cb) cb(modalData);
                        })
                    }
                },
                registerModalInstance(data) {
                    if (!client || !client.on) return;//if the request is not coming through Zendesk instance
                    client.on('instance.registered', (context) => {
                        if (context.location === 'modal') {
                            let instanceGuid = context.instanceGuid
                            let modalClient = client.instance(instanceGuid)
                            // Send modal this client's instance guid via trigger.
                            // The modal will use the guid to get a client instance back to this parent.
                            data=data?data:_self.zendeskInfo;
                            data.parentClientGuid=client._instanceGuid;
                            modalClient.trigger('send_data_to_modal', data);
                        }
                    });
                },
                createJSTree(elementId, cb) {

                    $(`#${elementId}`).jstree({
                        'core': {},
                        'plugins': ['sort', 'types']
                    });
                    $(`#${elementId}`).on("changed.jstree", function (e, data) {
                        if (data != null && data.node != null && data.node.original != null) {
                            //$("#SelectedIterationHiddenField").val(data.node.original.location);
                            if(cb) cb(data.node.original,e,data);
                        }
                    });

                },
                updateJSTreeData:function(elementId,data){
                    try {
                        if ($(`#${elementId}`).length > 0) {
                            $(`#${elementId}`).jstree(true).settings.core.data = data;
                            $(`#${elementId}`).jstree(true).refresh();
                        }
                    } catch (err) {
                        console.log(JSON.stringify(err));
                    }
                },
                handleTfsAreaIteration(selPath,type,userInfo){
                    let isTfsUrl=userInfo.devOpsUrl.toLowerCase().trim().indexOf('/tfs/')>=0;
                    if(isTfsUrl && selPath){
                        if(type=='Area'){
                            selPath=selPath.replace('\\Zone\\','\\');//one tfs client
                        }
                        if(type=='Iteration'){
                            selPath=selPath.replace('\\Itération\\','\\');//one tfs client
                        }
                    }
                    return selPath;
                },
                setJSTreeDefValue(elementId,defValue){
                    if(defValue){
                        $(`#${elementId}`).jstree(true).select_node(defValue);
                    }
                },
                capitalizeFirstLetter(string) {
                    if(!string) string;
                    return string.charAt(0).toUpperCase() + string.slice(1);
                },
                applyDatePicker(elementId,cb){
                    // return $(`${elementId}`).datepicker({
                    // 	autoclose:true,
                    // 	todayBtn:'linked',
                    // 	todayHighlight:true
                    // }).on('changeDate', function(ev){
                    // 	let date=ev.date;
                    //     //date cleared
                    //     if(ev.target.value=='')
                    // 	    date=null;
                    //     if(cb) cb(date,ev);
                    //     $(ev).datepicker('hide');
                    // });
                },
                createHtmlEditor:function(elementId,elementName,defaultContent,cb){
                    if (typeof ClassicEditor === 'undefined') return;
                    //https://codepen.io/david-felipe-huertas/pen/PoNqJgM?editors=1111

                    ClassicEditor.create( document.querySelector( `#${elementId}` ),
                        {
                            removePlugins: ['CKFinderUploadAdapter', 'CKFinder', 'ImageUpload', 'MediaEmbed'],
                            //removePlugins: ['CKFinderUploadAdapter', 'CKFinder', 'EasyImage', 'Image', 'ImageCaption', 'ImageStyle', 'ImageToolbar', 'ImageUpload', 'MediaEmbed'],

                        }
                    ).then( editor => {
                        if (typeof applyCKEditorConfig !== 'undefined'){
                            applyCKEditorConfig(editor);
                        }

                        if(defaultContent) editor.setData(defaultContent);

                        if(cb) cb(editor,null);
                        else _self.editorObj=editor;
                    })
                        .catch(error => {
                            console.log('classic editor error', error);
                        if(cb) cb(null,error);
                        else _self.editorObj=null;
                    });
                },
                createHtmlEditor_images:function(elementId,elementName,defaultContent,cb){
                    if (typeof ClassicEditor === 'undefined') return;
                    //https://codepen.io/david-felipe-huertas/pen/PoNqJgM?editors=1111

                    ClassicEditor.create( document.querySelector( `#${elementId}` ),
                        {
                            toolbar: {
                                items: [
                                    'heading', '|',
                                    'fontfamily', 'fontsize', '|',
                                    'alignment', '|',
                                    'fontColor', 'fontBackgroundColor', '|',
                                    'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                                    'link', '|',
                                    'outdent', 'indent', '|',
                                    'bulletedList', 'numberedList', 'todoList', '|',
                                    'code', 'codeBlock', '|',
                                    'insertTable', '|',
                                    //'uploadImage', 'mediaEmbed','blockQuote', '|',//'imageUpload',
                                    'undo', 'redo'
                                ],
                                shouldNotGroupWhenFull: false

                            },
                            //language: "en",
                            image: {
                                toolbar: ["imageTextAlternative", "imageStyle:full", "imageStyle:side"],
                            },
                            licenseKey: "",
                            //removePlugins: ['CKFinderUploadAdapter', 'CKFinder', 'ImageUpload', 'MediaEmbed'],
                            //removePlugins: ['CKFinderUploadAdapter', 'CKFinder', 'EasyImage', 'Image', 'ImageCaption', 'ImageStyle', 'ImageToolbar', 'ImageUpload', 'MediaEmbed'],

                        }
                    ).then( editor => {
                        if (typeof applyCKEditorConfig !== 'undefined'){
                            applyCKEditorConfig(editor);
                        }

                        if(defaultContent) editor.setData(defaultContent);

                        //https://ckeditor.com/docs/ckeditor5/latest/framework/guides/deep-dive/upload-adapter.html
                        // editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                        //     return loader.file
                        //         .then(file => new Promise((resolve, reject) => {
                        //              resolve({ default: 'https://azure-devops.io/assets/img/apps/zendesk/App.png' });
                        //             // return _self.fn().getBase64(file, function (err,res) {
                        //             //     console.log('file', err, ' ', res);
                        //             //     if (err) return reject(err);
                        //             //     else { console.log('resolved');  }
                        //             // });
                        //         }));
                        //     //https://ckeditor.com/docs/ckeditor5/latest/framework/guides/deep-dive/upload-adapter.html
                        // };
                        if(cb) cb(editor,null);
                        else _self.editorObj=editor;
                    })
                        .catch(error => {
                            console.log('classic editor error', error);
                        if(cb) cb(null,error);
                        else _self.editorObj=null;
                    });
                },
                destoryEditorObj(){
                    if(_self.editorObj!=null){
                        _self.editorObj.destroy();
                    }
                },
                getHtmlEditorContent:function(cust_editorObj){
                    if(cust_editorObj){
                        return cust_editorObj.getData();
                    }
                    else if(_self.editorObj)
                        return _self.editorObj.getData();
                    else return null;
                },
                setHtmlEditorContent:function(content){
                    if(_self.editorObj)
                        return _self.editorObj.setData(content);
                    else return null;
                },
                clearHtmlEditorContent:function(){
                    if(_self.editorObj)
                        return _self.editorObj.setData('');
                    else return null;
                },
                getZendeskInfo(cb){
                    if(_self.zendeskInfo.credentials==null){
                        // _self.zendeskInfo.credentials={
                        //     hdLoginUrl : "https://devopsintegration.zendesk.com",
                        //     hdEmail:"support@devopsintegration.io",
                        //     hdToken: "TKt5iZ35vHDGyd9TVQnPcvpxewb6lbwBOEGwaL1R",
                        //     devOpsUrl:"https://dev.azure.com/devopsintegrationio",
                        //     devOpsToken:"opwemda2aftj2n4rmjawzle5gd46fy65zny4ghoeaun2aghupwbq",
                        //     requestType:"zendesk-devops"
                        // };
                        client.metadata().then(function(metadata) {
                         console.log('got the client meta data');
                            console.log(metadata);
                            if(cb) cb();
                        });
                        //if(cb) cb();

                    }else if(cb) {
                        cb();
                    }

                    //client.context().then(function(context) {
                        //console.log(context);
                        /*
                        {
                            "instanceGuid": "7712c893-bec7-4e00-9db0-87fbb0c12914",
                            "product": "support",
                            "account": {
                            "subdomain": "mondocam"
                            },
                            "location": 'ticket_sidebar',
                            "ticketId": 1234
                        }
                        */
                    //});

                    //client.on('app.registered', function(e) {
                        // do stuff
                    //});
                    //   client.has('app.registered', function(d){

                    //   }); // true
                    // client.has('app.activated', function(d){

                    // }); // false
                },
                clearMessage(){
                    _self.userMsg={show:false,type:'info',list:[]}
                },
                showClearIcon(str){
                    if(str && str.trim()!='')
                    return true;
                    else
                    return false;
                },
                showLoader(show) {
                    if(show){
                        _self.loading=true;
                    }else{
                        setTimeout(function(){_self.loading=false;},1000);
                    }
                },
                isMenuAllowed(menuName){
                    let requestPath=menuName?menuName:this.$route.meta.accessPath;
                    let isAllowed= authService.isMenuAllowed(requestPath);
                    if(!isAllowed && !menuName){
                        this.$router.push('/404');
                    }
                    return isAllowed;
                },
                removeNulls(obj) {
                    if (Array.isArray(obj)) {
                        return obj.filter(item => item !== null).map(item => this.removeNulls(item));
                    } else if (obj !== null && typeof obj === 'object') {
                        return Object.fromEntries(
                        Object.entries(obj)
                            .filter(([_, v]) => v !== null)
                            .map(([k, v]) => [k, this.removeNulls(v)])
                        );
                    } else {
                        return obj;
                    }
                },
                apiFormatedDate(date){
                    if(!date) return null;
                    let month=date.getUTCMonth()+1;
                    let dateDay=date.getUTCDate();
                    month=month<10?'0'+month.toString():month.toString();
                    dateDay=dateDay<10?'0'+dateDay.toString():dateDay.toString();
                    let formattedDate= `${date.getUTCFullYear().toString()}-${month}-${dateDay}`;
                    return formattedDate;
                },
                makeid(length) {
                    var text = "";
                    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                    length=length?length:5;
                    for (var i = 0; i < length; i++)
                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                    return text;
                },
                getParameterByName(name, url) {
                    if (!url) url = window.location.href;
                    name = name.replace(/[\[\]]/g, "\\$&");
                    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                        results = regex.exec(url);
                    if (!results) return null;
                    if (!results[2]) return '';
                    return decodeURIComponent(results[2].replace(/\+/g, " "));
                },
                isValidCommaSeparatedEmails(str){
                    if(!str || str.trim()=='') return true;
                    let emails=str.split(',');
                    let isAllValid=true;
                    for(var i=0; i<emails.length; i++){
                        let isValid=_self.isValidEmail(emails[i]);
                        if(isValid==false){
                            isAllValid=false;
                            break;
                        }
                    }
                    return isAllValid;
                },
                isValidEmail(str){
                    if(!str || str.trim()=='') return true;
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(str).toLowerCase());
                },
                clone(o) {
                    var newO,
                    i;

                    if (typeof o !== 'object') {
                    return o;
                    }
                    if (!o) {
                    return o;
                    }

                    if ('[object Array]' === Object.prototype.toString.apply(o)) {
                    newO = [];
                    for (i = 0; i < o.length; i += 1) {
                        newO[i] = _self.clone(o[i]);
                    }
                    return newO;
                    }

                    newO = {};
                    for (i in o) {
                    if (o.hasOwnProperty(i)) {
                        newO[i] = _self.clone(o[i]);
                    }
                    }
                    return newO;
                },
                getTimezoneByTxt(obj){
                    //https://raw.githubusercontent.com/dmfilipenko/timezones.json/master/timezones.json
                    let timezoneTxt=obj.timezone;
                    if(timezoneTxt){
                        let timeZoneList=timezoneJSON;
                        let timezone=timeZoneList.filter(d=>d.text==timezoneTxt)[0];
                        if(timezone)
                            obj.timezoneOffset=timezone.offset;
                    }else{
                        obj.timezoneOffset=null;
                    }
                },
                downloadAttachmentUrl(path){
                    let baseUrl=_self.baseUrl;
                    if(!path)return path;
                    if(path.startsWith('http://') || path.startsWith('https://')) return path;
                    return `${baseUrl}/static/${path}`;
                },
                scrollToTopOfPage(){
                    window.scrollTo(0,0);
                },
                fileSizeFormat(size){
                    let fileSizeInMb=size/(1000);
                    fileSizeInMb=fileSizeInMb.toFixed(2);
                    return fileSizeInMb;
                },
                invertColor(hex) {
                    let bw=true;
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    if (bw) {
                        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                            ? '#000000'
                            : '#FFFFFF';
                    }
                    // invert color components
                    r = (255 - r).toString(16);
                    g = (255 - g).toString(16);
                    b = (255 - b).toString(16);
                    // pad each with zeros and return
                    return "#" + _self.padZero(r) + _self.padZero(g) + _self.padZero(b);
                },
                padZero(str, len) {
                    len = len || 2;
                    var zeros = new Array(len).join('0');
                    return (zeros + str).slice(-len);
                },
                //for decimal validation
                isDecimalValid(val){
                    if(val && val.toString().endsWith('.'))
                        return true;
                    else
                        return false;
                },
                sortStrCol(dataArr,colName,isAsc){
                    dataArr.sort(function(a, b) {
                        a[colName] = a[colName] ? a[colName] : '';
                        b[colName] = b[colName] ? b[colName] : '';
                        return isAsc ? a[colName].localeCompare(b[colName]) : b[colName].localeCompare(a[colName]);
                    });
                    return dataArr;
                },
                sortNumCol(dataArr,colName,isAsc){
                    dataArr.sort(function(a, b) {
                        return isAsc ? a[colName] - b[colName] : b[colName] - a[colName];
                    });
                    return dataArr;
                },
                sortDateCol(dataArr,colName,isAsc){
                    dataArr.sort(function(a, b) {
                        let colValA = a[colName] ?new Date(a[colName]) : '';
                        let colValB = b[colName] ?new Date(b[colName]) : '';
                        return isAsc ? colValA - colValB : colValB - colValA;
                    });
                    return dataArr;
                },
                removeQuotesFromStr(val){
                    val=val?val.toString():'';
                    val=val.replace(/'/g,'');
                    val=val.replace(/"/g,'');
                    val=val.trim();
                    return val;
                },
                isJsonString:function(str) {
                    try {
                        JSON.parse(str);
                    } catch (e) {
                        return false;
                    }
                    return true;
                },
                isJSONEmpty(obj) {
                    for(var key in obj) {
                        if(obj.hasOwnProperty(key))
                            return false;
                    }
                    return true;
                },
                jsonConcat(obj1, obj2) {
                    for (var key in obj2) {
                        obj1[key] = obj2[key];
                    }
                    return obj1;
                },
                daysDiff(date1,date2){
                    const MS_PER_DAY = 1000*60*60*24;
                    const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
                    const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
                    return Math.floor((utc1 - utc2) / MS_PER_DAY);
                },
                monthDiff(d1, d2) {
                    var months;
                    months = (d2.getFullYear() - d1.getFullYear()) * 12;
                    months -= d1.getMonth();
                    months += d2.getMonth();
                    return months <= 0 ? 0 : months;
                },
                filterUnique(dataArr){
                    let uniqDataArr=[];
                    $.each(dataArr, function(i, el){
                        if($.inArray(el, uniqDataArr) === -1) uniqDataArr.push(el);
                    });
                    return uniqDataArr;
                },
                filterUniqueObjArray(dataArr,key){
                    let flags = [], output = [];
                    for(var i=0; i<dataArr.length; i++) {
                        if( flags[dataArr[i][key]]) continue;
                        flags[dataArr[i][key]] = true;
                        output.push(dataArr[i]);
                    }
                    return output;
                },
                showPopover(id){
                    _self.$root.$emit('bv::hide::popover');
                    _self.$root.$emit('bv::show::popover',id);
                },
                hidePopover(id){
                    _self.$root.$emit('bv::hide::popover');
                },
                showTooltip(id){
                    _self.$root.$emit('bv::hide::tooltip');
                    _self.$root.$emit('bv::show::tooltip',id);
                },
                hideTooltip(id){
                    _self.$root.$emit('bv::hide::tooltip');
                },
                formatCSV(val){
                    val=val?val.toString():'';
                    val=val.replace(/'/g,"\'\'");
                    val=val.replace(/"/g,'\"\"');
                    //val=val?val.replace(/,/g,' '):'';
                    //val=(val && val.indexOf(",")>=0)?`"${val}"`:`${val}`;
                    val=`"${val}"`;
                    return val;
                },
                isDateValid(str){
                    let isDateValid=false;
                    let parsedDate;
                    try{
                        if(str)
                        parsedDate= moment.utc(String(str)).format('DD MMM, YYYY hh:mm');

                        if(parsedDate!="Invalid date")
                            isDateValid=true;
                        }
                    catch(ex){
                        isDateValid=false;
                    }
                    return isDateValid;
                },
            }

        },
        filter(){
            let _self=this;
            return {
                arrayDisp:function(arr){
                    if(str){
                        return _self.$options.filters.arrayDisp(arr);
                    }
                },
                roundNumber:function(str){
                    if(str){
                        return _self.$options.filters.roundNumber(str);
                    }
                },
                formatPrice:function(str){
                    if(str){
                        return _self.$options.filters.formatPrice(str);
                    }
                },
                formatDate:function(str){
                    if(str){
                        return _self.$options.filters.formatDate(str);
                    }else{
                        return null;
                    }
                },
                formatDateTime:function(str){
                    if(str){
                    return _self.$options.filters.formatDateTime(str);
                    //return moment.utc(String(str)).format('DD-MMM-YY hh:mm A');
                    }
                },
                format2DigitYearDate:function(str){
                    if(str){
                    return _self.$options.filters.format2DigitYearDate(str);
                    }
                },
                formatTime:function(str){
                    if(str){
                        return _self.$options.filters.formatTime(str);
                    }
                },
                numberWithCommas(str){
                    return _self.$options.filters.numberWithCommas(str);
                },
                formatNumber(val){
                    return _self.$options.filters.formatNumber(val);
                },
                parseToIntDefaultZero(val){
                    return _self.$options.filters.parseToIntDefaultZero(val);
                },
                parseToInt(val){
                    return _self.$options.filters.parseToInt(val);
                },
                parseToFloat(val){
                    return _self.$options.filters.parseToFloat(val);
                },
                toString(val){
                    return _self.$options.filters.toString(val);
                },
                shorten10Chars(str){
                    return _self.$options.filters.shorten10Chars(str);
                },
                shorten50Chars(str){
                    return _self.$options.filters.shorten50Chars(str);
                },
                shorten100Chars(str){
                    return _self.$options.filters.shorten100Chars(str);
                },
                shortenNotesChars(str){
                    return _self.$options.filters.shortenNotesChars(str);
                },
                shortenTitleChars(str){
                    return _self.$options.filters.shortenTitleChars(str);
                },
                shortenStripDescriptionChars(str){
                    return _self.$options.filters.shortenStripDescriptionChars(str);
                },
                stripHtml(str){
                    return _self.$options.filters.stripHtml(str);
                },
                toTitleCase(str){
                    return _self.$options.filters.toTitleCase(str);
                }
            }
        }
    },
    filters:{
        arrayDisp:function(arr){
            if(!arr) return null;
            if(!Array.isArray(arr)) return null;
            return arr.join(', ');
        },
        roundNumber:function(str){
            if(str==0)
              return str;

            if(str && str!='' && !isNaN(parseInt(str))){
              return parseInt(str);
            }
          },
        formatPrice:function(priceAmt,c1, d1, t1){
            if(!priceAmt || priceAmt==null || priceAmt==0)return 0;
            let n = priceAmt;
            let c = isNaN(c1 = Math.abs(c1)) ? 2 : c1;
            let d = d1 == undefined ? "." : d1;
            let t = t1 == undefined ? "," : t1;
            let s = n < 0 ? "-" : "";
            let i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
            let j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        },
        formatDate:function(str){
            if(str){
                let authResponse=authService.getAuthResponse();
                let timezoneOffset=null;
                if(authResponse){
                  timezoneOffset= JSON.parse(authResponse).User.TimezoneOffset;
                }
                if(timezoneOffset!=null){
                  timezoneOffset=timezoneOffset*60;
                  return moment.utc(String(str)).utcOffset(timezoneOffset).format('DD-MMM-YY');
                }else{
                  return moment.utc(String(str)).format('DD-MMM-YY');
                  //return moment.utc(String(str)).utc().format('MM-DD-YYYY');
                }
            }
        },
        formatDateTime:function(str){
            if(str){
                let timezoneOffset=new Date().getTimezoneOffset();
                if(timezoneOffset!=null){
                  timezoneOffset=timezoneOffset*-1;
                  return moment.utc(String(str)).utcOffset(timezoneOffset).format('DD-MMM-YY hh:mm A');
                }else{
                  return moment.utc(String(str)).format('DD-MMM-YY hh:mm A');
                }
            }
        },
        format2DigitYearDate:function(str){
            if(str){
                return moment.utc(str, "MM/D/YY").format('DD-MMM-YY');
            }
        },
        formatTime:function(str){
            if(str){
                return moment.utc(String(str)).format('hh:mm A');
            }
        },//
        numberWithCommas(x) {
            return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):x;
        },
        formatNumber(val){
            if(!val) return '-';
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        parseToIntDefaultZero(val){
            if(!val) return 0;
            if(!isNaN(parseInt(val))){
                return parseInt(val);
            }
            return 0;
        },
        parseToInt(val){
            if(!val) return null;
            if(!isNaN(parseInt(val))){
                return parseInt(val);
            }
            return null;
        },
        parseToFloat(val){
            if(!val) return null;
            if(!isNaN(parseFloat(val))){
                return parseFloat(val);
            }
            return null;
        },
        toString(val){
            return val?val.toString():null;
        },
        shorten10Chars(str){
            let _self=this;
            if(str && str.length>10){
                str=str.substr(0,10)+'...';
            }
            return str;
        },
        shorten50Chars(str){
            let _self=this;
            if(str && str.length>50){
                str=str.substr(0,50)+'...';
            }
            return str;
        },
        shorten100Chars(str){
            let _self=this;
            if(str && str.length>100){
                str=str.substr(0,100)+'...';
            }
            return str;
        },
        shortenNotesChars(str){
            let _self=this;
            if(str && str.length>50){
                str=str.substr(0,50)+'...';
            }
            return str;
        },
        shortenTitleChars(str){
            let _self=this;
            if(str && str.length>75){
                str=str.substr(0,75)+'...';
            }
            return str;
        },
        shortenStripDescriptionChars(str) {
            let _self = this;
            str = str ? _self.stripHtml(str) : '';
            if(str && str.length>200){
                str=str.substr(0,200)+'...';
            }
            return str;
        },
        toTitleCase(str){
            if(str){
                return str.replace(
                    /\w\S*/g,
                    function(txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    }
                );
            }
            return str;
        },
        stripHtml(html) {
            return (html?html.replace(/<[^>]*>/g, ''):'');
        }
    },
}
